import React from 'react';
import { useDrag } from 'react-dnd';
import {
    FlexDiv,
    Block,
    Heading4,
    TextDefault,
} from '@awarego-ui/components';
import { Card, CardBody } from 'reactstrap';

const BlockItem = ({ blockType, config }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'block',
        item: { blockType },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    return (
        <div
            ref={drag}
            className={`block-item ${isDragging ? 'dragging' : ''}`}
            style={{ opacity: isDragging ? 0.5 : 1 }}
        >
            <Card hoverable>
                <CardBody>
                    <FlexDiv alignCenter gap={12}>
                        <TextDefault fontSize={20}>{config.icon}</TextDefault>
                        <FlexDiv column>
                            <Heading4>{config.name}</Heading4>
                            <TextDefault lighter>{config.category}</TextDefault>
                        </FlexDiv>
                    </FlexDiv>
                </CardBody>
            </Card>
        </div>
    );
};

const PresentationItem = ({ presentationType, config }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'presentation',
        item: { presentationType },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    return (
        <div
            ref={drag}
            className={`presentation-item ${isDragging ? 'dragging' : ''}`}
            style={{ opacity: isDragging ? 0.5 : 1 }}
        >
            <Card hoverable>
                <CardBody>
                    <FlexDiv alignCenter gap={12}>
                        <TextDefault fontSize={20}>{config.icon}</TextDefault>
                        <FlexDiv column>
                            <Heading4>{config.name}</Heading4>
                            <TextDefault lighter>{config.category}</TextDefault>
                        </FlexDiv>
                    </FlexDiv>
                </CardBody>
            </Card>
        </div>
    );
};

function BlockPalette({
    blockTypes,
    presentationTypes,
    onAddBlock,
    onSetPresentation,
}) {
    const interactiveBlocks = Object.entries(blockTypes).filter(
        ([_, config]) => config.category === 'interactive'
    );
    const layoutBlocks = Object.entries(blockTypes).filter(
        ([_, config]) => config.category === 'layout'
    );
    const presentations = Object.entries(presentationTypes);

    return (
        <div className="block-palette">
            <Block padding={16} gap={16}>
                <Heading4>Interactive Blocks</Heading4>
                <FlexDiv column gap={8}>
                    {interactiveBlocks.map(([type, config]) => (
                        <BlockItem
                            key={type}
                            blockType={type}
                            config={config}
                        />
                    ))}
                </FlexDiv>

                <Heading4>Layout Blocks</Heading4>
                <FlexDiv column gap={8}>
                    {layoutBlocks.map(([type, config]) => (
                        <BlockItem
                            key={type}
                            blockType={type}
                            config={config}
                        />
                    ))}
                </FlexDiv>

                <Heading4>Presentations</Heading4>
                <FlexDiv column gap={8}>
                    {presentations.map(([type, config]) => (
                        <PresentationItem
                            key={type}
                            presentationType={type}
                            config={config}
                        />
                    ))}
                </FlexDiv>
            </Block>
        </div>
    );
}

export default BlockPalette;
